<template>
  <div>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loading"
    >

      <b-card>
        <b-form @submit.prevent="applySearch">
          <b-container fluid>
            <b-row class="mb-2">
              <b-col
                v-if="$can('read', 'trips-filter')"
                md="4"
              >
                <div>

                  <label for="states">Search by state</label>
                  <v-select
                    id="states"
                    v-model="currState"
                    placeholder="No state selected"
                    label="label"
                    :options="stateOptions"
                    :reduce="(option) => option.key"
                    :clearable="false"
                  />
                  <!-- @input="applySearch" -->
                </div>
              </b-col>
              <b-col md="4">
                <label for="user">Search by User Phone number</label>
                <b-form-input
                  id="user"
                  v-model="queryParams.user_phone"
                  type="number"
                  placeholder="User Phone number"
                />
              </b-col>
              <b-col md="4">
                <label for="driver">Search by Driver Phone number</label>
                <b-form-input
                  id="driver"
                  v-model="queryParams.driver_phone"
                  placeholder="Driver Phone number"
                />
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col
                md="4"
              >
                <label for="date1">From Date</label>
                <b-form-datepicker
                  id="date1"
                  v-model="dateTimeFilter.fromDate"
                  :min="disableDateAt()"
                />
                <label
                  class="mt-1"
                >
                  From Time</label>
                <b-input-group>
                  <flat-pickr
                    v-model="dateTimeFilter.fromTime"
                    class="form-control"
                    :config="{ enableTime: true, noCalendar: true, time_24hr: true}"
                  />
                  <b-input-group-append>
                    <b-button
                      v-if="dateTimeFilter.fromTime"
                      class="btn-icon"
                      variant="primary"
                      @click="dateTimeFilter.fromTime = ''"
                    >
                      <feather-icon icon="XIcon" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col
                md="4"
              >
                <label for="date2">To Date</label>
                <b-form-datepicker
                  id="date2"
                  v-model="dateTimeFilter.toDate"
                  :min="disableDateAt()"
                />
                <label
                  class="mt-1"
                  for="time2"
                >To Time</label>
                <b-input-group>
                  <flat-pickr
                    v-model="dateTimeFilter.toTime"
                    class="form-control"
                    :config="{ enableTime: true, noCalendar: true, time_24hr: true}"
                  />
                  <b-input-group-append>
                    <b-button
                      v-if="dateTimeFilter.toTime"
                      class="btn-icon"
                      variant="primary"
                      @click="dateTimeFilter.toTime = ''"
                    >
                      <feather-icon icon="XIcon" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col
                md="4"
                class="d-flex flex-column justify-content-between"
              >
                <div>
                  <label for="trip">Search by trip number</label>
                  <b-form-input
                    id="trip"
                    v-model="tripId"
                    type="number"
                    placeholder="Trip number"
                  />
                </div>
                <div
                  v-if="$can('read', 'trips-filter')"
                  class="mt-2 d-flex justify-content-between align-items-center"
                >
                  <b-button
                    :disabled="!canSearch"
                    variant="primary"
                    type="submit"
                  >
                    Search
                  </b-button>
                  <b-button
                    variant="outline-primary"
                    @click="clearFilter"
                  >
                    Clear
                  </b-button>
                  <b-button
                    :disabled="!canSearch"
                    class="btn-icon rounded-circle"
                    variant="flat-primary"
                    type="submit"
                  >
                    <feather-icon
                      icon="RefreshCwIcon"
                    />
                  </b-button>
                  <!-- <h6 class="m-0">
                    Total: {{ totalTrips }}
                  </h6> -->
                </div>
              </b-col>
            </b-row>
          </b-container>
        </b-form>
        <b-table
          hover
          striped
          selectable
          select-mode="single"
          :items="tripsList"
          :fields="tableColumns"
          show-empty
          empty-text="In order to get results you need to search for specific data."
          class="text-center"
          @row-selected="navigateToTripDetails($event[0].id)"
        >
          <template #cell(state)="data">
            <trip-status-badge
              :status="data.item.state"
              style="letter-spacing: -0.5px; font-size: 11px"
            />
          </template>
        </b-table>
        <base-pagination
          v-model="queryParams.page"
          :total="totalTrips"
          @input="fetchTripsList"
          @new-per-page="queryParams.size = $event"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BTable, BOverlay, BButton, BContainer, BRow, BCol, BFormInput, BFormDatepicker, BForm,
  BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import tripsStore from '../store'
import useTripsList from '../hooks/useTripsList'
import BasePagination from '@/UI/BasePagination.vue'
import tripStatusBadge from '../components/TripStatusBadge.vue'

export default {
  components: {
    flatPickr,
    BCard,
    BButton,
    BTable,
    BOverlay,
    BasePagination,
    BFormCheckbox,
    tripStatusBadge,
    BContainer,
    BRow,
    BCol,
    BFormDatepicker,
    vSelect,
    BFormInput,
    BForm,
    BInputGroup,
    BInputGroupAppend,
  },
  setup(_, ctx) {
    useRegisterStoreModule('trips', tripsStore)

    return {
      ...useTripsList(ctx),
    }
  },
}
</script>

<style scoped>
</style>
